<template>
  <section>

    <b-tabs type="is-toggle">
      <b-tab-item label="Delivered">
        <b-field grouped group-multiline>
          <b-select v-model="defaultSortDirection">
            <option value="asc">Default sort direction: ASC</option>
            <option value="desc">Default sort direction: DESC</option>
          </b-select>
          <b-select v-model="perPage">
            <option value="5">5 per page</option>
            <option value="10">10 per page</option>
            <option value="15">15 per page</option>
            <option value="20">20 per page</option>
          </b-select>
          <!-- <div class="control is-flex">
            <b-switch v-model="isPaginationSimple" :disabled="!isPaginated">Simple pagination</b-switch>
          </div> -->
        </b-field>
        <b-table
          :data="isEmpty ? [] : data"
          striped
          hoverable
          ref="table"
          :per-page="perPage"
          paginated
          :current-page.sync="currentPage"
          :pagination-simple="isPaginationSimple"
          :default-sort-direction="defaultSortDirection"
          default-sort="user.first_name"
          :opened-detailed="defaultOpenedDetails"
          detailed
          detail-key="id"
          @details-open="(row, index) => $toast.open(`Expanded ${row.user.first_name}`)"
          :show-detail-icon="showDetailIcon"
          focusable
        >

          <template slot-scope="props">
            <b-table-column field="id" label="ID" width="40" numeric sortable>
              {{ props.row.id }}
            </b-table-column>

            <b-table-column field="user.first_name" label="First Name" sortable>
              <template v-if="showDetailIcon">
                {{ props.row.user.first_name }}
              </template>
              <template v-else>
                <a @click="toggle(props.row)">
                  {{ props.row.user.first_name }}
                </a>
              </template>
            </b-table-column>

            <b-table-column field="user.last_name" label="Last Name" sortable>
              {{ props.row.user.last_name }}
            </b-table-column>

            <b-table-column field="date" label="Date" sortable centered>
                        <span class="tag is-success">
                            {{ new Date(props.row.date).toLocaleDateString() }}
                        </span>
            </b-table-column>

            <b-table-column label="Gender">
              <b-icon pack="fa"
                      :icon="props.row.gender === 'Male' ? 'mars' : 'venus'">
              </b-icon>
              {{ props.row.gender }}
            </b-table-column>
          </template>

          <template slot="detail" slot-scope="props">
            <article class="media">
              <figure class="media-left">
                <p class="image is-64x64">
                  <img src="/static/img/placeholder-128x128.png">
                </p>
              </figure>
              <div class="media-content">
                <div class="content">
                  <p>
                    <strong>{{ props.row.user.first_name }} {{ props.row.user.last_name }}</strong>
                    <small>@{{ props.row.user.first_name }}</small>
                    <small>31m</small>
                    <br>
                    Lorem ipsum dolor sit amet, consectetur adipiscing elit.
                    Proin ornare magna eros, eu pellentesque tortor vestibulum ut.
                    Maecenas non massa sem. Etiam finibus odio quis feugiat facilisis.
                  </p>
                  <div class="buttons">
                    <button class="button is-success">Send</button>
                    <button class="button"><router-link :to="`/client/${props.row.id}`">Get Ad</router-link></button>
                    <a class="button">View Details</a>
                    <a class="button is-danger is-outlined">Hide</a>
                  </div>
                </div>
              </div>
            </article>
          </template>
        </b-table>
      </b-tab-item>

      <b-tab-item label="Undelivered">

      </b-tab-item>
    </b-tabs>
  </section>
</template>

<script>
import data from '@/data/sample.json'

export default {
  name: 'LeadsList',
  data () {
    return {
      data,
      defaultOpenedDetails: [1],
      showDetailIcon: true,
      isPaginationSimple: false,
      defaultSortDirection: 'asc',
      currentPage: 1,
      perPage: 10,
      isEmpty: false
    }
  },
  methods: {
    toggle (row) {
      this.$refs.table.toggleDetails(row)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/components/LeadsList.vue